import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Rating } from "primereact/rating";
import { Tag } from "primereact/tag";
import { useParams } from "react-router-dom";
import { TabView, TabPanel } from "primereact/tabview";
import { BusinessInfo } from "./BusinessInfo";
import { Users } from "./users";
import Whitelabel from "./whitelabel";
import { Fieldset } from "primereact/fieldset";
import Subscription from "./Subscription";
import FbRegistration from "../FbRegistrationModule";

export const Company = () => {
  const { companyId } = useParams();

  useEffect(async () => {}, []);
  return (
    <div className="card">
      <TabView>
        <TabPanel header="Business Info">
          <BusinessInfo />
        </TabPanel>
        <TabPanel header="Users">
          <Users />
        </TabPanel>
        <TabPanel header="Subscription">
          <Subscription />
        </TabPanel>
        <TabPanel header="Configuration">
          <Whitelabel />
        </TabPanel>
        <TabPanel header="Facebook Connection">
          <Fieldset style={{ background: "#f8f8fc" }}>
            <FbRegistration />
          </Fieldset>
        </TabPanel>
        {/* <TabPanel header="Conversation Analytics">
                    <p className="m-0">
                        Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam,
                        eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo
                        enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui
                        ratione voluptatem sequi nesciunt. Consectetur, adipisci velit, sed quia non numquam eius modi.
                    </p>
                </TabPanel> */}
      </TabView>
    </div>
  );
};
